import { Component } from '@angular/core';
import { AppSettingsService } from '../../shared/app-settings/app-settings.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.css']
})
export class UserMenuComponent {

  public user: any = this.appSettings.data.user;
  public userName: string = this.user.first_name || this.user.email;

  constructor(
    private appSettings: AppSettingsService
  ) { }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/user-menu/user-menu.component.ts